import {ApolloProvider} from "@apollo/client";
import classNames from "classnames";
import {CookiesProvider} from "react-cookie";
import {IconContext} from "react-icons";
import {Outlet, ScrollRestoration} from "react-router";

import {UserContextProvider} from "@/components/context/UserContextProvider.tsx";
import {ZendeskMessengerProvider} from "@/components/context/ZendeskMessengerContext.tsx";
import {NavBar} from "@/components/navBar/NavBar.tsx";
import {NavBarContextProvider, useNavBar} from "@/components/navBar/NavBar.utils.tsx";
import {ZendeskMessenger} from "@/components/zendeskMessenger/ZendeskMessenger.tsx";
import client from "@/lib/api/apolloClient.ts";
import {UpErrorBoundary} from "@/lib/handlers/UpErrorBoundary.tsx";

export const Layout = () => {
  const methods = useNavBar();

  return (
    <UpErrorBoundary>
      <ApolloProvider client={client}>
        <CookiesProvider>
          <UserContextProvider>
            <NavBarContextProvider {...methods}>
              <ZendeskMessengerProvider>
                <IconContext.Provider value={{size: "1.25em", style: {verticalAlign: "text-top"}}}>
                  <div className="app-container">
                    <NavBar />
                    <div
                      className={classNames(
                        "outlet-container",
                        methods.isMenuOpen ? "outlet-container-not-scrollable" : "outlet-container-scrollable"
                      )}
                    >
                      <UpErrorBoundary>
                        <ScrollRestoration />
                        <Outlet />
                      </UpErrorBoundary>
                    </div>
                    <ZendeskMessenger />
                  </div>
                </IconContext.Provider>
              </ZendeskMessengerProvider>
            </NavBarContextProvider>
          </UserContextProvider>
        </CookiesProvider>
      </ApolloProvider>
    </UpErrorBoundary>
  );
};
